import React from 'react'

const Dr_G_Sree_Lakshmi = () => {
  return (
    <>
            <div id='Topmargin1' >
                <div className='about_banner'>
                    <img src='DOCTORS.png' className='about_image' alt=''></img>
                </div>
            </div>
            <div className='container docter_content'>
                <h2>Dr. G.Sree Lakshmi</h2>
                <div className='row'>
                    <div className='col-md-6 col-sm-12 Doctor_image_Content'>
                        <img id='doctor_image' src='WhatsApp-Image-2022-06-08-at-3.16.52-PM.jpeg' alt='Doctor Image'></img>
                        <h3>Dr. G.Sree Lakshmi</h3>
                        <p><b>Consultant Fertility Specialist,Obstetrician & Gynecologist</b></p>
                        <p><b>MBBS, M.S (OBG)</b></p>
                    </div>

                    <div className='col-md-6 col-sm-12 Doctor_Text'>
                        <p>Dr.G.Sree Lakshmi MBBS, MS (OBG) is a Fertility and Gynaecologyspecialist of Pinnamaneni Hospital. She has been active as a medical practitioner for over 10 years, which includes her services at Nova IVF, Vijayawada. Our doctor’swork speaks volumes about her abilities and accomplishments.She pursued her fellowship in Reproductive Medicine, obstetric ultrasound FMAS, DMAS, Minimal Access surgery. Dr.G.Sree Lakshmi has strong reputation in Andhra Pradesh for providing excellent fertility, obstetrics and gynaecology treatments. She stands out in the field because of her efforts to improve the well-being of her patients. The expertise level she has by treating many couples makes patients feel safe and comfortable while getting treated by our doctor.</p>
                    </div>
                </div>
            </div>
        </>
  )
}

export default Dr_G_Sree_Lakshmi